import React from "react";
import LogInForm from "./LogInForm";

const LogInSection = () => {
  return (
    <div className="log-in sign-block">
      <div className="title">Login to Your Account</div>
      <div className="sub-title">Please log in to access your MonLis account.</div>
      <LogInForm />
    </div>
  );
};

export default LogInSection;
